// Utilidades de formatação para Collection Orders e outros módulos
const DEFAULT_LANGUAGE = import.meta.env.VITE_DEFAULT_LANGUAGE || 'es-GT'

export const mapCollectionOrderStatus = (status: number): string => {
  switch (status) {
    case 1:
      return 'Pendiente de pago'
    case 2:
      return 'Liquidado'
    case 3:
      return 'Devuelto'
    case 4:
      return 'Venció'
    default:
      // Este caso não deveria ocorrer pois filtramos apenas status 1, 2, 3
      return 'Pendiente de pago' // Fallback para status 1
  }
}

export const formatCurrencyGTQ = (value: number | null | undefined): string => {
  if (value === null || value === undefined || isNaN(value)) return 'Q 0.00'
  try {
    return new Intl.NumberFormat(DEFAULT_LANGUAGE, {
      style: 'currency',
      currency: 'GTQ',
      minimumFractionDigits: 2,
    }).format(value)
  } catch {
    return `Q ${Number(value).toFixed(2)}`
  }
}

export const formatTimeString = (dateString?: string): string => {
  if (!dateString) return ''
  try {
    const date = new Date(dateString)

    return date.toLocaleTimeString(DEFAULT_LANGUAGE, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
  } catch {
    return dateString
  }
}

export const formatDateShort = (dateString?: string): string => {
  if (!dateString) return ''
  try {
    const date = new Date(dateString)
    return date.toLocaleDateString(DEFAULT_LANGUAGE)
  } catch {
    return dateString
  }
}
